import { Outlet } from "react-router-dom";

/** Layout racine : fond tokenisé autour de l'Outlet (sans animation globale). */
export function RootLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Outlet />
    </div>
  );
}
